import { ApolloClient, NormalizedCacheObject } from "@apollo/client";
import { createContext, ReactElement, useContext } from "react";

import { useTenantApolloClient } from "~frontend/client";

export const NonCacheClearingApolloClientContext =
  createContext<ApolloClient<NormalizedCacheObject> | null>(null);

export default function NonCacheClearingApolloClientProvider({
  children,
}: {
  children: ReactElement;
}): ReactElement | null {
  const tenantClient = useTenantApolloClient();

  return (
    <NonCacheClearingApolloClientContext.Provider value={tenantClient}>
      {children}
    </NonCacheClearingApolloClientContext.Provider>
  );
}

export function useNonCacheClearingApolloClient(): ApolloClient<NormalizedCacheObject> {
  const client = useContext(NonCacheClearingApolloClientContext);

  if (!client) {
    throw new Error("NonCacheClearingApolloClientContext not found");
  }

  return client;
}
